import axios from 'axios';

// Configure base URL (proxy is usually set in vite.config.ts)
// But for now we assume /api/v1 proxy or direct URL
const API_BASE = '/api/v1/dashboard';

export const fetchProductionStats = async () => {
    const response = await axios.get(`${API_BASE}/stats/production`);
    return response.data;
};

export const fetchPriceTrend = async (period: 'Month' | 'Year') => {
    const response = await axios.get(`${API_BASE}/stats/price-trend`, { params: { period } });
    return response.data;
};

export const fetchResourceFlow = async () => {
    const response = await axios.get(`${API_BASE}/stats/resource-flow`);
    return response.data;
};
